import React from 'react';
import "../../../styles/DefenceStyles/DefenceSupport.css"
import Hero from './hero';
import SupportCards from './SupportCards';
import SupportIntegration from './SupportIntegration';
import Supportjourney from './Supportjourney';

export default function DefenceSupport() {
  return (
    <>
      {/* Section 1 */}
          <Hero/>

      {/* Section 2 */}
       <SupportCards/>

      {/* Section 3 */}
    <SupportIntegration/>

      {/* Section 4 */}
      <Supportjourney/>

    </>
  );
}
